<!-- 下載全支付小幫手：/helper_download -->
<template>
  <div class="layout_wrapper">
    <div class="container_wrapper">
      <div class="download_phone">
        <picture>
          <source
            media="(min-width: 768px) and (max-width: 1024px)"
            :srcset="require('@/assets/imgs/download/helper@2x.png')"
          >
          <source
            media="(max-width: 414px)"
            :srcset="require('@/assets/imgs/download/helper.png')"
          >
          <img
            class="download_phone_img"
            :srcset="require('@/assets/imgs/download/helper@3x.png')"
          >
        </picture>
      </div>

      <div class="download_info">
        <h2 class="download_title">
          立即下載
        </h2>

        <div class="download_link">
          <div class="download_link_group">
            <img
              alt="arrow_down"
              class="download_link_qrcode"
              :srcset="require('@/assets/imgs/download/merchant_qrcode.svg')"
            >

            <p class="download_link_des">
              還沒安裝全支付小幫手APP嗎?
            </p>

            <div class="download_link_wrapper">
              <div
                class="download_google_play"
                @click="downloadRedirect"
              >
                <picture>
                  <source
                    media="(min-width: 768px) and (max-width: 1024px)"
                    :srcset="require('@/assets/imgs/download/google_play@2x.png')"
                  >
                  <source
                    media="(max-width: 414px)"
                    :srcset="require('@/assets/imgs/download/google_play.png')"
                  >
                  <img
                    alt="arrow_down"
                    class="download_google_play_img"
                    :srcset="require('@/assets/imgs/download/google_play@3x.png')"
                  >
                </picture>
              </div>

              <div
                class="download_app_store"
                @click="downloadRedirect"
              >
                <picture>
                  <source
                    media="(min-width: 768px) and (max-width: 1024px)"
                    :srcset="require('@/assets/imgs/download/app_store@2x.png')"
                  >
                  <source
                    media="(max-width: 414px)"
                    :srcset="require('@/assets/imgs/download/app_store.png')"
                  >
                  <img
                    alt="arrow_down"
                    class="download_app_store_img"
                    :srcset="require('@/assets/imgs/download/app_store@3x.png')"
                  >
                </picture>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <component :is="dialogName" />
  </div>
</template>

<script>
import { onMounted } from 'vue';
import device from 'current-device';

export default {
  name: 'HelperDownload',
  setup () {
    const downloadRedirect = () => {
      window.location.href = 'https://pxpayplusmerchant.page.link/Zi7X';
    };

    onMounted(() => {
      if (!device.desktop()) downloadRedirect();
    });

    return {
      downloadRedirect
    };
  }
};
</script>

<style scoped lang="scss">
@import '@/scss/common/common.scss';
@import '@/scss/common/layout.scss';

.layout_wrapper {
  .container_wrapper {
    display: flex;
    position: relative;
  }

  .download_phone {
    flex-basis: 410px;
    margin-right: 128px;
    position: relative;
    text-align: center;

    &::before {
      background: url('~@/assets/imgs/common/circle@3x.png')repeat-x right center/contain;
      content: '';
      height: 410px;
      right: 0;
      position: absolute;
      top: 50%;
      transform: translateY(-50%);
      width: 960px;
      z-index: -1;
    }

    .download_phone_img {
      height: auto;
      width: 246px;
      vertical-align: middle;
    }
  }

  .download_info {
    flex: 1;
  }

  .download_title {
    @include font-size-bold-54;

    margin: 40px 0 50px;
  }

  .download_link_group {
    display: flex;
    margin-bottom: 30px;

    .download_link_qrcode {
      height: 224px;
      vertical-align: middle;
      width: 224px;
      background: #fff;
    }

    .download_link_des {
      display: none;
    }

    .download_link_wrapper {
      padding-top: 17px;
      margin-left: 50px;
      width: 224px;

      >div {
        cursor: pointer;
      }

      .download_google_play {
        margin-bottom: 30px;
      }

      .download_google_play_img,
      .download_app_store_img {
        width: 100%;
        vertical-align: middle;
      }
    }
  }

  .download_link_description {
    font-size: 13px;
    line-height: 22px;

    p {
      color: $mono_80;
      margin: 0;
    }
  }

  ::v-deep(.p-dialog-header) {
    display: none !important;
  }
}

// 1024
@include RWD_1024 {
  .layout_wrapper {
    .download_title {
      margin-bottom: 40px;
    }

    .download_phone {
      flex-basis: auto;
      margin-right: 79px;

       &::before {
         height: 300px;
         right: -100px;
       }
    }

    .download_link {
      .download_link_qrcode {
        height: 224px;
        width: 224px;
      }

      .download_link_wrapper {
        margin-left: 31px;
        width: 224px;
      }
    }
  }
}

// 768
@include RWD_768 {
  .layout_wrapper {
    .container_wrapper {
      padding-top: 106px;
    }

    .download_phone {
      flex-basis: 315px;
      margin-right: 100px;
      text-align: right;

       &::before {
         height: 300px;
         right: -80px;
       }

       .download_phone_img {
        height: auto;
        width: 225px;
      }
    }

    .download_info {
      flex: 1;
      display: flex;
      flex-direction: column;
      justify-content: flex-end;
    }

    .download_title {
      @include font-size-bold-40;

      left: 0;
      margin: 0;
      position: absolute;
      top: 0;
    }

    .download_link {
      .download_link_qrcode {
        display: none;
      }

      .download_link_wrapper {
        margin-left: 0;
        width: 192px;

        .download_google_play {
          margin-bottom: 20px;
        }
      }
    }
  }
}

// 414
@include RWD_414 {
  .layout_wrapper {
    padding: 10px 30px 0px;

    .container_wrapper {
      flex-direction: column;
      height: calc(100vh - 90px);
      padding-top: 76px;
    }

    .download_phone {
      flex-basis: 365px;
      margin-bottom: 50px;
      margin-right: 0;
      text-align: center;

      &::before {
         height: 278px;
         right: -30px;
       }

       .download_phone_img {
        height: auto;
        width: 175px;
      }
    }

    .download_info {
    }

    .download_title {
      @include font-size-bold-36;
    }

    .download_link {
      background: $mono_10;
      flex-direction: column;
      left: 50%;
      padding: 24px 30px 30px;
      margin-left: -30px;
      margin-right: -30px;
      margin-left: -50vw;
      margin-bottom: 0;
      position: relative;
      width: 100vw;

      >div {
        max-width: 375px;
        margin-left: auto;
        margin-right: auto;
      }

      .download_link_group {
        flex-direction: column;
      }

      .download_link_des {
        @include font-size-16;

        display: block;
        margin-top: 0;
        margin-bottom: 24px;
      }

      .download_link_wrapper {
        display: flex;
        justify-content: flex-start;
        width: 100%;

        .download_google_play {
          margin-right: 20px;
        }

        .download_google_play,
        .download_app_store {
          margin-bottom: 0;
          width: 167px;
        }
      }
    }
  }
}
</style>

<style lang="scss">
@media screen and (max-width: 767px) {
  #app {
    min-height: calc(100vh - 70px - 621px);
  }
}
</style>
